export default __webpack_public_path__ + "static/media/Anexo Resolucion Aviso Funciones IVC (1).8bd31787.pdf";